<template>
    <div class="bg-light my-2 my-md-3">
        <h4 class=" text-center">Benutzerdefinierte Händleransicht</h4>
        <div class >
        </div>
        <b-table sticky-header striped :items="vendorTableData" class="mx-3 border rounded" style="min-height: calc(100vh - 130px);">
            <template v-for="header in vendorHeaderData.customVendorHeaders"  v-slot:[`cell(${header})`]="{ item }" >
                <div :key="header">
                    <click-to-edit-component v-model="item[header]" :dataId="item.id" :dataPath="`/custom_vendor_interface/customInfo/${header}`"/>
                </div>
            </template>
        </b-table>
	</div>
</template>
<script>
export default {
    props: ['vendorData', 'vendorHeaderData'],
    data(){
        return {
            selectedHeaderInput : null,
            tableHeaders: null,
            vendorTableData: null,
            clickToEditInput: ""
        }
    },
    created(){
        this.tableHeaders = this.vendorHeaderData.customVendorBaseHeaders.concat(this.vendorHeaderData.customVendorHeaders);

        this.vendorTableData = this.vendorData.map(vendor => {
            if(vendor.customInfo){
                vendor.customInfo = JSON.parse(vendor.customInfo)
            }
            const newVendor = {}
            this.tableHeaders.forEach(key => {
                if(Object.hasOwn(vendor, key)){
                    newVendor[key] = vendor[key]
                } else if (Object.hasOwn(vendor.customInfo, key)){
                    newVendor[key] = vendor.customInfo[key]
                } else{
                    newVendor[key] = ""
                }
            });
            return newVendor
        })
    }
}
</script>